// Shows a small popover under the header bag when an item is added to the cart, and hides it after 1 second.
//
// The theme dispatches `theme:product:add` on the add button (bubbling) once /cart/add succeeds, with the
// added line in `detail.response`. Nothing is requested here; the popover markup comes from
// snippets/cart-added.liquid. Guests never reach this (the guard script stops the add).
(function () {
  const DELAY = 1000;
  const popover = document.querySelector('[data-cart-added]');
  if (!popover) return;

  let timer = 0;

  const text = (selector, value) => {
    popover.querySelector(selector).textContent = value || '';
  };

  // The visible bag: the header holds a mobile and a desktop link, only one of them takes space
  const bag = () => [...document.querySelectorAll('[data-cart-toggle]')].find((el) => el.offsetParent !== null);

  const place = () => {
    const target = bag();
    if (!target) return;
    const rect = target.getBoundingClientRect();
    popover.style.top = `${Math.round(rect.bottom + 8)}px`;
    popover.style.right = `${Math.max(16, Math.round(document.documentElement.clientWidth - rect.right))}px`;
  };

  const hide = () => {
    clearTimeout(timer);
    popover.hidden = true;
  };

  const show = (item) => {
    text('[data-cart-added-vendor]', item.vendor);
    text('[data-cart-added-name]', item.product_title);
    text('[data-cart-added-quantity]', popover.dataset.quantityLabel.replace('__COUNT__', item.quantity));
    text('[data-cart-added-price]', window.theme.formatMoney(item.final_line_price, theme.moneyWithCurrencyFormat));

    if (item.url) popover.querySelector('[data-cart-added-product]').href = item.url;

    place();
    popover.hidden = false;
    clearTimeout(timer);
    timer = setTimeout(hide, DELAY);
  };

  document.addEventListener('theme:product:add', (event) => {
    const item = event.detail && event.detail.response;
    if (item && item.product_title) show(item);
  });

  popover.querySelector('[data-cart-added-close]').addEventListener('click', hide);
  popover.addEventListener('mouseenter', () => clearTimeout(timer));
  popover.addEventListener('mouseleave', () => {
    clearTimeout(timer);
    timer = setTimeout(hide, DELAY);
  });
})();
